export default "__VITE_PUBLIC_ASSET__3bb2bfa5__"